import { BaseListViewStore, ProductHyperLinkCellData } from 'core/stores';
import { observable, action, makeObservable } from 'mobx';
import FulfillmentOrderStore from './FulfillmentOrderStore';

class FulfillmentOrderItemsListViewStore extends BaseListViewStore {
	@observable change = false;
	noDataItem = true;

	constructor(rootStore) {
		super(rootStore, {
			listStore: new FulfillmentOrderStore(rootStore),
			queryParams: {
				embed: [],
				filter: null,
				ignore: true,
			},
			findFunction: 'findFulfillmentOrderItems',
			tableData: {
				columns: [
					{
						key: 'product.name',
						title: 'FULFILLMENTORDERITEMSVIEW.NAME',
						selected: true,
						width: 200,
						filter: null,
						sortable: false,
						resizable: false,
					},
					{
						key: 'sku',
						title: 'FULFILLMENTORDERITEMSVIEW.SKU',
						dataCell: ProductHyperLinkCellData,
						isFoDetailsPage: true,
						routeName: 'master.app.main.product.list.detail',
						selected: true,
						width: 200,
						filter: null,
						sortable: false,
						resizable: false,
					},
					{
						key: 'quantity',
						title: 'FULFILLMENTORDERITEMSVIEW.QUANTITY',
						selected: true,
						width: 200,
						filter: null,
						sortable: false,
						resizable: false,
					},
					...(rootStore.orderDetailViewStore.fulfillmentOrderItems.some(
						item => item.orderLine.product.isMultiProduct === true
					)
						? [
								{
									key: 'orderLine.product.mainSku',
									title: 'FULFILLMENTORDERITEMSVIEW.PARENTSKU',
									selected: true,
									width: 200,
									filter: null,
									resizable: false,
									sortable: false,
								},
						  ]
						: []),
				],
				sortObject: [],
				actions: {},
			},
			permissions: {
				read: () => this.authStore.hasPermission('productSection.read'),
			},
			routes: {
				detail: id =>
					this.rootStore.routerStore.goTo('master.app.main.product.list.detail', {
						id,
					}),
			},
		});
		makeObservable(this);
	}

	@action.bound
	setAsChanged = () => {
		this.change = !this.change;
	};

	@action.bound async findFulfillmentOrderItems() {}
}

export default FulfillmentOrderItemsListViewStore;
